export default class TutorialEvent { }

TutorialEvent.CLOSE_REQUEST = "TutorialEvent.CLOSE_REQUEST";